import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, } from '@angular/core'
import { map } from 'rxjs/operators'
import { Facet, RoutingService } from '@spartacus/core'
import { Subscription } from 'rxjs'
import { SearchUtilsService } from '../../services/search-utils.service'
import { CmsFacetService } from '../../../cms/services/cms-search/cms-facet.service'
import { SmartSearchService } from '../../../cms/services/cms-search/smart-search.service'

@Component({
  selector: 'mb-search-filters',
  templateUrl: './mb-search-filters.component.html',
  styleUrls: ['./mb-search-filters.component.scss']
})
export class MbSearchFiltersComponent implements OnInit, OnDestroy {

  @Input()
  isCategoryPage = false

  @Input()
  isCmsPage = false

  @Input()
  facetsList: Facet[] | undefined

  @Input()
  search: string | undefined

  @Input()
  jobs?: boolean

  @Output()
  expandFacets = new EventEmitter<boolean>()

  query$ = this.routingService.getRouterState().pipe(
    map(state => state?.state?.params?.['query'] || state?.state?.queryParams?.['query'])
  )
  queryContent$ = this.routingService.getRouterState().pipe(
    map(state => state?.state?.params?.['query'] || state?.state?.queryParams?.['queryContent'])
  )
  isFacetsVisible: boolean = false
  subscription: Subscription = new Subscription()
  showContentTab: boolean = false
  cmsFacets: Facet[] | undefined

  constructor (private routingService: RoutingService,
               private renderer: Renderer2,
               private elem: ElementRef,
               private cdRef: ChangeDetectorRef,
               private smartSearchService: SmartSearchService,
               private cmsFacetService: CmsFacetService,
               private searchUtilsService: SearchUtilsService) {
    this.subscription.add(this.searchUtilsService.isFacetsExpandedFromOutside$.subscribe((isFacetsVisible: boolean) => {
        this.isFacetsVisible = !isFacetsVisible
        this.toggleContentWidth()
      })
    )
  }

  ngOnInit (): void {
    this.subscription.add(this.smartSearchService.showContentTab$.subscribe(showContentTab => {
      this.showContentTab = showContentTab
      this.cdRef.detectChanges()
    }))
    this.subscription.add(this.cmsFacetService.facets$.subscribe(facets => (this.cmsFacets = facets)))
  }

  ngOnDestroy (): void {
    this.isFacetsVisible = true
    this.toggleContentWidth()
    this.subscription.unsubscribe()
  }

  toggleContentWidth (): void {
    if (!this.isFacetsVisible) {
      this.shrinkElements()
    } else {
      this.expandElements()
    }
    this.isFacetsVisible = !this.isFacetsVisible
    this.cmsFacetService.setAreFacetsVisible(this.isFacetsVisible)
    this.searchUtilsService.toggleIsFacetExpanded(this.isFacetsVisible)
  }

  shrinkElements (): void {
    if (this.isCategoryPage) {
      this.expandFacets.emit(true)
    } else {
      const isTopFilterSlotAvailable = !!(this.elem?.nativeElement?.parentElement?.parentElement?.querySelector(
        '.SearchTopFiltersContentSlot'))
      const resultHeader = this.elem?.nativeElement?.parentElement?.parentElement?.querySelector('.SearchResultsHeaderContentSlot')
      const resultList = this.elem?.nativeElement?.parentElement?.parentElement?.querySelector('.SearchResultsListContentSlot')
      this.elem?.nativeElement?.parentElement?.classList?.add('mb-facets-expanded')
      resultHeader?.classList?.add('mb-facets-expanded')
      resultList?.classList?.add('mb-facets-expanded')
      if (!isTopFilterSlotAvailable
        && (!!resultHeader?.classList?.contains('mb-facets-expanded') || !!resultList?.classList?.contains('mb-facets-expanded'))
      ) {
        resultHeader?.classList?.add('mb-UN-grid-row-change')
        resultList?.classList?.add('mb-UN-grid-row-change')
      }
    }
  }

  expandElements (): void {
    if (this.isCategoryPage) {
      this.expandFacets.emit(false)
    } else {
      this.elem?.nativeElement?.parentElement?.classList?.remove('mb-facets-expanded')
      this.elem?.nativeElement?.parentElement?.parentElement?.querySelector('.SearchResultsHeaderContentSlot')?.classList?.remove(
        'mb-facets-expanded')
      this.elem?.nativeElement?.parentElement?.parentElement?.querySelector('.SearchResultsListContentSlot')?.classList?.remove(
        'mb-facets-expanded')
    }
  }
}
